// EntityDetailModal — "Ver detalle" de una entidad: muestra el registro (traído por su GET-by-id)
// como lista limpia de campo → valor. Reemplaza el dump crudo del probador por una vista usable.
import { Modal } from '@/kit';

function fmtValue(v: unknown): string {
    if (v === null || v === undefined) return '—';
    if (typeof v === 'boolean') return v ? 'Sí' : 'No';
    if (typeof v === 'string') return v;
    if (typeof v === 'number') return String(v);
    return JSON.stringify(v);
}

export interface EntityDetailModalProps {
    title: string;
    /** El registro a mostrar (o null = cerrado). Típicamente lo trae un GET-by-id. */
    record: Record<string, unknown> | null;
    onClose: () => void;
}

export function EntityDetailModal({ title, record, onClose }: EntityDetailModalProps) {
    return (
        <Modal isOpen={!!record} onClose={onClose} title={title} size="md">
            {record ? (
                <dl className="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
                    {Object.entries(record).map(([k, v]) => (
                        <div key={k} className="min-w-0 space-y-0.5">
                            <dt className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
                                {k}
                            </dt>
                            <dd className="break-words text-[13px] text-foreground">{fmtValue(v)}</dd>
                        </div>
                    ))}
                </dl>
            ) : null}
        </Modal>
    );
}
